import { render } from "./Button-List.vue?vue&type=template&id=1f5edba0&scoped=true"
import script from "./Button-List.vue?vue&type=script&lang=js"
export * from "./Button-List.vue?vue&type=script&lang=js"

import "./Button-List.vue?vue&type=style&index=0&id=1f5edba0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\OneDrive\\工作案件\\前端管理介面\\vue3-adminlte3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5edba0"]])

export default __exports__